import {
  Availability,
  SearchOperatorOptions,
  SearchOption
} from '@components/show_page/sections/section_search/SearchTypes';

export const searchOptions = (isNarrowView = false): SearchOption[] => ([
  { label: isNarrowView ? t('Any') : t('Any of these terms'), value: SearchOperatorOptions.OR },
  { label: isNarrowView ? t('All') : t('All of these terms'), value: SearchOperatorOptions.AND },
  { label: isNarrowView ? t('Contains') : t('Contains this phrase'), value: SearchOperatorOptions.Quoted },
  { label: isNarrowView ? t('Exact') : t('Exactly this phrase'), value: SearchOperatorOptions.Strict },
]);

export const assetStatusOptions = [
  { label: t('All'), value: undefined },
  { label: t('Approved'), value: Availability.Approved },
  { label: t('Unapproved'), value: Availability.Unapproved },
  { label: t('Draft'), value: Availability.Draft },
  { label: t('Expired'), value: Availability.Expired }
];
